const USER_PERSONA_TYPES = Object.freeze({
  WORD_POWER: 'wordpower',
  NEWS_LETTER: 'newsletter',
  PERSONAL_LINK: 'personal_link',
  PERSONAL_LINK_FA_PROFILE: 'personal_link_fa_profile',
  WEBSITE_PROSPECT: 'website_prospect',
  DIRECT_URL_CA: 'direct_url_ca',
  DIRECT_URL: 'direct_url',
});

export default USER_PERSONA_TYPES;
